import LocaleCurrency from 'locale-currency';

export const getUserCurrencyCode = (supportedCurrencies: Array<string>): string | null => {
    const userLocale = navigator.language || navigator.languages[0] || '';
    const userLocaleCurrencyCode = LocaleCurrency.getCurrency(userLocale);

    if (userLocaleCurrencyCode === null) {
        return null;
    }

    const isSupported = supportedCurrencies.some((currency) => currency === userLocaleCurrencyCode);
    return isSupported ? userLocaleCurrencyCode : null;
};
